var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({attrs:{"src":_vm.finalSrc,"alt":_vm.alt}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }